var map = {
	"./baox.svg": "W/uW",
	"./clear.svg": "4KGF",
	"./closure.svg": "h7H0",
	"./custom.svg": "0LDi",
	"./eye.svg": "YFNw",
	"./fina.svg": "Wlcb",
	"./fina_clear_center.svg": "Jnbd",
	"./financial.svg": "QG8Q",
	"./first-menu.svg": "lz51",
	"./fund.svg": "yULq",
	"./gold.svg": "yr23",
	"./new_fund.svg": "0y9/",
	"./new_plateform.svg": "5Z8O",
	"./new_test.svg": "mVZb",
	"./notice.svg": "qyfJ",
	"./plateform.svg": "XBKV",
	"./product.svg": "9Fyr",
	"./project.svg": "ICck",
	"./report.svg": "Pmo1",
	"./second-menu.svg": "yAmp",
	"./system.svg": "zz4u",
	"./test.svg": "Zkq0",
	"./toug.svg": "hDdu",
	"./unfold.svg": "1a7y",
	"./workflow.svg": "R02l",
	"./zhib.svg": "59dw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 1